import React from "react";
import "./Education.css";

const Education = () => {
  const educationProducts = [
    {
      id: 1,
      name: "LMS (Learning Management System)",
      description: "Comprehensive platform for delivering, tracking, and managing educational content and training programs.",
      features: [
        "Course creation and management",
        "Interactive learning modules",
        "Assessment and grading system",
        "Certification tracking",
        "Mobile learning support",
        "Discussion forums"
      ],
      expectations: [
        "30% improvement in training completion rates",
        "Centralized knowledge management",
        "Detailed learner progress tracking",
        "SCORM and xAPI compliant content"
      ],
      customization: [
        "White-label branding",
        "Custom course templates",
        "Single sign-on integration",
        "Advanced reporting dashboards"
      ]
    },
    {
      id: 2,
      name: "Student Management System (SMS)",
      description: "Complete solution for educational institutions to manage student lifecycle from admission to alumni.",
      features: [
        "Admission and enrollment",
        "Attendance tracking",
        "Gradebook and report cards",
        "Timetable management",
        "Fee collection",
        "Parent portal"
      ],
      expectations: [
        "80% reduction in administrative paperwork",
        "Real-time communication with parents",
        "Automated report generation",
        "Compliance with education board requirements"
      ],
      customization: [
        "Curriculum-specific configurations",
        "Extracurricular activity tracking",
        "Scholarship management",
        "Transportation module"
      ]
    },
    {
      id: 3,
      name: "Assessment/Exam Management System (AMS)",
      description: "Comprehensive platform for creating, delivering, and analyzing assessments and examinations.",
      features: [
        "Test creation tools",
        "Multiple question types",
        "Automated grading",
        "Plagiarism detection",
        "Performance analytics",
        "Secure exam delivery"
      ],
      expectations: [
        "60% faster assessment creation",
        "Detailed competency gap analysis",
        "Secure remote proctoring",
        "Psychometric analysis"
      ],
      customization: [
        "Custom scoring rubrics",
        "Branded assessment portals",
        "Adaptive testing algorithms",
        "Integration with LMS platforms"
      ]
    },
    {
      id: 4,
      name: "School Parent App",
      description: "Mobile application for seamless communication between schools and parents.",
      features: [
        "Attendance notifications",
        "Grade access",
        "Event calendar",
        "Fee payments",
        "Secure messaging",
        "Document sharing"
      ],
      expectations: [
        "Improved parent engagement",
        "Real-time updates on student progress",
        "Reduced paper communication",
        "Increased transparency"
      ],
      customization: [
        "Branded mobile application",
        "Multi-language support",
        "Custom notification rules",
        "School-specific modules"
      ]
    },
    {
      id: 5,
      name: "EdTech Course Platform (Udemy-like)",
      description: "Online marketplace for creating, hosting, and selling educational courses.",
      features: [
        "Course builder with multimedia support",
        "Student enrollment management",
        "Progress tracking",
        "Certification system",
        "Payment processing",
        "Instructor dashboard"
      ],
      expectations: [
        "Monetize educational content",
        "Global student reach",
        "Automated course delivery",
        "Engaging learning experience"
      ],
      customization: [
        "Custom marketplace branding",
        "Subscription models",
        "Affiliate programs",
        "API integrations"
      ]
    },
    {
      id: 6,
      name: "Tutor Booking App",
      description: "Platform connecting students with qualified tutors for personalized learning.",
      features: [
        "Tutor profiles and verification",
        "Booking and scheduling system",
        "Virtual classroom",
        "Payment processing",
        "Review and rating system",
        "Progress tracking"
      ],
      expectations: [
        "Easy tutor discovery",
        "Flexible scheduling options",
        "Secure payment processing",
        "Quality-controlled tutoring"
      ],
      customization: [
        "Subject-specific matching",
        "Video lesson integration",
        "Package deals and subscriptions",
        "Parent monitoring dashboard"
      ]
    }
  ];

  return (
    <div className="education-container">
      <div className="education-header">
        <h1>Education & Learning Solutions</h1>
        <p className="subtitle">Innovative digital tools to transform teaching and learning experiences</p>
      </div>

      <div className="education-grid">
        {educationProducts.map((product) => (
          <div key={product.id} className="education-card">
            <div className="education-card-header">
              <h2>{product.name}</h2>
              <p className="education-card-description">{product.description}</p>
            </div>

            <div className="education-card-details">
              <div className="education-card-section">
                <h3>Key Features</h3>
                <ul>
                  {product.features.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
              </div>

              <div className="education-card-section">
                <h3>What you can Expect</h3>
                <ul>
                  {product.expectations.map((expectation, index) => (
                    <li key={index}>{expectation}</li>
                  ))}
                </ul>
              </div>

              <div className="education-card-section">
                <h3>Customization Options</h3>
                <ul>
                  {product.customization.map((option, index) => (
                    <li key={index}>{option}</li>
                  ))}
                </ul>
              </div>
            </div>

           {/*
<div className="education-card-footer">
  <button className="education-demo-button">Request Demo</button>
</div>
*/}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Education;